<template>
    <v-card flat color="grey darken-3">
        <v-card-text>
            <v-container fluid>
                <h2 class="font-weight-dark" style="color: white;">Select Gigs/Jobs</h2>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-switch
                        v-model="gigs"
                        label="Maid - Cooking"
                        color="purple accent-3"
                        value="cook"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Maid - Home Cleaning"
                        color="purple accent-3"
                        value="cleaning"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Maid - Nany"
                        color="purple accent-3"
                        value="nany"
                        dark
                        hide-details></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-switch
                        v-model="gigs"
                        label="Car Wash"
                        color="purple accent-3"
                        value="car_wash"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Gardening"
                        color="purple accent-3"
                        value="gardener"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Trash Pickup"
                        color="purple accent-3"
                        value="trash_pickup"
                        dark
                        hide-details></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-switch
                        v-model="gigs"
                        label="Tutoring"
                        color="purple accent-3"
                        value="tutor"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Driver(Shoufer)"
                        color="purple accent-3"
                        value="driver"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Satellite Dish Maintenance"
                        color="purple accent-3"
                        value="satellite_dish"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Computer Maintenance"
                        color="purple accent-3"
                        value="computer_maintenance"
                        dark
                        hide-details></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-switch
                        v-model="gigs"
                        label="Hair Dressing/Stylist"
                        color="purple accent-3"
                        value="hair_dressing"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Barber"
                        color="purple accent-3"
                        value="barber"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Makeup Artist"
                        color="purple accent-3"
                        value="makeup_artist"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Masseuse/Masseur"
                        color="purple accent-3"
                        value="massage"
                        dark
                        hide-details></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-switch
                        v-model="gigs"
                        label="Moving Help"
                        color="purple accent-3"
                        value="moving_help"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="Carpenter"
                        color="purple accent-3"
                        value="carpenter"
                        dark
                        hide-details></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                        <v-switch
                        v-model="gigs"
                        label="Electrician"
                        color="purple accent-3"
                        value="electrician"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="gigs"
                        label="House Painting"
                        color="purple accent-3"
                        value="painting"
                        dark
                        hide-details></v-switch>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <hr>
        <v-card-text>
            <v-container fluid>
                <h2 class="font-weight-dark" style="color: white;">Select City</h2>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-switch
                        v-model="city"
                        label="Addis Ababa"
                        color="purple accent-3"
                        value="addisababa"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Dire Dawa"
                        color="purple accent-3"
                        value="diredawa"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Mek'ele"
                        color="purple accent-3"
                        value="mekelle"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Adama"
                        color="purple accent-3"
                        value="adama"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Bahir Dar"
                        color="purple accent-3"
                        value="bahirdar"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Gonder"
                        color="purple accent-3"
                        value="gonder"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Dessie"
                        color="purple accent-3"
                        value="dessie"
                        dark
                        hide-details></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-switch
                        v-model="city"
                        label="Awasa"
                        color="purple accent-3"
                        value="awasa"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Jimma"
                        color="purple accent-3"
                        value="jimma"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Bishoftu"
                        color="purple accent-3"
                        value="bishoftu"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Harar"
                        color="purple accent-3"
                        value="harar"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Debre Birhan"
                        color="purple accent-3"
                        value="debrebirhan"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Jigjiga"
                        color="purple accent-3"
                        value="jigjiga"
                        dark
                        hide-details></v-switch>
                        <v-switch
                        v-model="city"
                        label="Shashamane"
                        color="purple accent-3"
                        value="shashamane"
                        dark
                        hide-details></v-switch>
                        </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="updatePreference">Update Preferences</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            gigs: [],
            city:''
        }
    },
    methods: {
        updatePreference() {
            
        }
    }
}
</script>

<style>
</style>